export const defaultColumnsBySection = {
  users: ['id', 'first_name', 'last_name', 'email', 'user_type', 'organization_name', 'status', 'created_at'],
  'course-enrollments': ['course_id', 'course_name', 'enrollment_count'],
  organizations: ['organization_name', 'total_licenses', 'used_licenses', 'remaining_licenses'],
  surveys: ['survey_title', 'survey_type', 'organization_name', 'responses_count', 'created_at'],
  'course-completions': ['course_name', 'username', 'user_name', 'course_start_date', 'course_end_date', 'score', 'lesson_status'],
  vouchers: ['code', 'scope', 'status', 'used_count', 'usage_limit', 'redemptions_count', 'start_date', 'end_date'],
  tickets: ['ticket_number', 'subject', 'status', 'organization_name', 'created_by_name', 'created_at', 'resolved_at'],
  transactions: ['payment_id', 'user_name', 'user_email', 'payment_type', 'final_amount', 'status', 'transaction_id', 'created_at']
};

export const sectionNavItems = (basePath, scope = 'super-admin') => {
  const items = [
    { key: 'users', label: 'Users', path: `${basePath}/users` },
    { key: 'course-enrollments', label: 'Course Enrollments', path: `${basePath}/course-enrollments` },
    { key: 'organizations', label: 'Org Licenses', path: `${basePath}/organizations` },
    { key: 'surveys', label: 'Surveys', path: `${basePath}/surveys` },
    { key: 'course-completions', label: 'Course Completions', path: `${basePath}/course-completions` },
    { key: 'vouchers', label: 'Vouchers', path: `${basePath}/vouchers` },
    { key: 'tickets', label: 'Support Tickets', path: `${basePath}/tickets` }
  ];

  if (scope === 'super-admin') {
    items.push({ key: 'transactions', label: 'Transactions', path: `${basePath}/transactions` });
  }

  return items;
};

export const filterConfigBySection = {
  users: [
    {
      key: 'user_type',
      label: 'User Type',
      type: 'select',
      options: [
        { value: '', label: 'All User Types' },
        { value: 'individual_learner', label: 'Individual Learner' },
        { value: 'individual_instructor', label: 'Individual Instructor' },
        { value: 'org_learner', label: 'Org Learner' },
        { value: 'org_instructor', label: 'Org Instructor' }
      ],
      showOrgWhen: ['org_learner', 'org_instructor']
    }
  ],
  'course-enrollments': [
    { key: 'course_id', label: 'Course', type: 'course' },
    { key: 'organization_id', label: 'Organization', type: 'organization', includeIndividual: true }
  ],
  'course-completions': [
    { key: 'course_id', label: 'Course', type: 'course' },
    { key: 'organization_id', label: 'Organization (Optional)', type: 'organization', optional: true }
  ],
  tickets: [
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: '', label: 'All Statuses' },
        { value: 'open', label: 'Open' },
        { value: 'in_progress', label: 'In Progress' },
        { value: 'resolved', label: 'Resolved' },
        { value: 'closed', label: 'Closed' }
      ]
    }
  ],
  transactions: [
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: '', label: 'All Statuses' },
        { value: 'success', label: 'Success' },
        { value: 'pending', label: 'Pending' },
        { value: 'failed', label: 'Failed' }
      ]
    }
  ]
};
